/* BaristaYOU mobile sticky / language selector collision fix */
(function(){
  'use strict';
  function init(){
    var selector=document.querySelector('.by-mobile-language-selector');
    if(!selector||selector.dataset.byStickyGuard==='true') return;
    selector.dataset.byStickyGuard='true';
    function bar(){return document.querySelector('[data-by-mobile-buy-bar]');}
    function setHidden(hidden){
      var b=bar(); if(!b) return;
      b.classList.toggle('by-language-in-view',!!hidden);
      b.setAttribute('aria-hidden',hidden?'true':'false');
    }
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(e){setHidden(e.isIntersecting);});
      },{root:null,threshold:0,rootMargin:'0px 0px 72px 0px'});
      io.observe(selector);
    }else{
      function check(){
        var r=selector.getBoundingClientRect();
        setHidden(r.top<window.innerHeight&&r.bottom>0);
      }
      window.addEventListener('scroll',check,{passive:true});
      window.addEventListener('resize',check,{passive:true});
      check();
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();